import { IPublicClientApplication } from '@azure/msal-browser';
import { NotificationRequest } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  createNotification,
  deleteNotification,
  getNotifications,
  updateNotification,
  updateNotificationStatus,
} from './index';

export const createStaffNotificationsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getNotifications: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getNotifications(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getNotifications', isInFlight);
    },
  ),
  createNotification: (instance: IPublicClientApplication, notification: NotificationRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createNotification(fetchContext, notification, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createNotification', isInFlight);
    },
  ),
  updateNotification: (instance: IPublicClientApplication, notificationId: number, notification: NotificationRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNotification(fetchContext, notificationId, notification, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNotification', isInFlight);
    },
  ),
  updateNotificationStatus: (instance: IPublicClientApplication, notificationId: number, isActive: boolean) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNotificationStatus(fetchContext, notificationId, isActive, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNotificationStatus', isInFlight);
    }
  ),
  deleteNotification: (instance: IPublicClientApplication, notificationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteNotification(fetchContext, notificationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteNotification', isInFlight);
    },
  ),
});
